import { gql } from "_graphql-types-frontend/gql";

export const MUTATION_PLAN_QUERY = gql(/* GraphQL */ `
  query MutationPlan($id: Int!) {
    mutationPlan(id: $id) {
      id
      title
      status
      expiresAt
      createdBy
      steps {
        id
        sequence
        mutationName
        description
        input
        status
        result
        errorMessage
        fieldSchema
        lockedFields
        liveSnapshot
        valueLabels
        previousState
        resultLinks
        filePreviewUrl
        dataSources
      }
    }
  }
`);

export const APPROVE_MUTATION_PLAN = gql(/* GraphQL */ `
  mutation ApproveMutationPlan($planId: Int!) {
    approveMutationPlan(planId: $planId) {
      id
      status
    }
  }
`);

export const CANCEL_MUTATION_PLAN = gql(/* GraphQL */ `
  mutation CancelMutationPlan($planId: Int!) {
    cancelMutationPlan(planId: $planId)
  }
`);


export const UPDATE_MUTATION_STEP_INPUT = gql(/* GraphQL */ `
  mutation UpdateMutationStepInput($stepId: Int!, $input: JSON!) {
    updateMutationStepInput(stepId: $stepId, input: $input) {
      id
      input
    }
  }
`);

export const RETRY_FAILED_STEPS = gql(/* GraphQL */ `
  mutation RetryFailedSteps($planId: Int!) {
    retryFailedSteps(planId: $planId) {
      id
      status
    }
  }
`);
